import { useContext, useEffect } from 'react';
import { Context } from '../UIShell/context';

export const usePageTitle = (
    title$: null | string = null,
): {
    title: string;
    setTitle: (title: string) => void;
} => {
    const [state, { setTitle }] = useContext(Context);
    const title = state.getIn(['page', 'title']);

    useEffect(() => {
        if (title$ && title !== title$) {
            setTitle(title$);
        }
    }, [title$]);

    return { setTitle, title };
};
